import { BiSend } from "react-icons/bi";
import { IconLink } from "../../UI/IconLink/IconLink";
import { ScrollBtn } from "../ScrollBtn/ScrollBtn";

import styles from "./Content.module.css";

export const Content = () => {
  return (
    <div className={styles.content}>
      <h2 className={styles.title}>Hey there!👋 I'm Ahmed</h2>
      <h3 className={styles.subtitle}>Frontend Developer</h3>
      <p className={styles.description}>
        Ready to take your digital presence to the next level, I'm here to turn
        your vision into reality.
      </p>
      <IconLink to="#contact" text="Contact Me" Icon={BiSend} />
      <ScrollBtn />
    </div>
  );
};
